import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ButtonType } from '../../models/constants/button-type.constant';

@Injectable()
export class ErrorGridDialogMessageService {
    constructor() { }

    private message = new Subject<ButtonType>();

    // Observable string streams
    message$ = this.message.asObservable();

    // Service message commands
    PublishMessage(message: ButtonType): void {
        this.message.next(message);
    }
}
